import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
// Central entitlement check — resolved by the backend (plans.py); components never hard-code plan logic.
export const useEntitlement = (key) => { const { user } = useContext(AuthCtx); return !user?.entitlements || !!user.entitlements.features?.[key]; };

export function RequireAuth({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="auth-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-slate-900" />
      </div>
    );
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  return children;
}
